import React from 'react'
import classNames from 'classnames'
import { gsap, Power2, ScrollTrigger } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)

export const BackgroundColorContext = React.createContext(null)

class Chapter extends React.Component {
    constructor(props) {
        super(props)

        this.domRef = React.createRef()
    }

    componentDidMount() {
        document.addEventListener('allimagesloaded', () => {
            gsap.from(this.domRef.current, {
                    opacity: 0,
                    y: 100,
                    ease: Power2.easeOut,
                    scrollTrigger: {
                        trigger: this.domRef.current,
                        toggleActions: 'restart',
                        start: 'top bottom',
                        end: 'top center',
                        scrub: true
                    }
            })
        })
    }

    titleToId(title) {
        return title.toLowerCase().replace(/[^a-zA-Z]/g, '')
    }
    
    render() {
        const { title, anchor, children, backgroundColor, textColor } = this.props

        return (
            <section className={classNames('chapter', backgroundColor && 'has-background' )} ref={this.domRef} style={{backgroundColor: backgroundColor && backgroundColor, color: textColor && textColor}}>
                <h2 className="chapter-heading" id={anchor ? anchor : this.titleToId(title)} dangerouslySetInnerHTML={{ __html: title }} />
                <div className="chapter-content">
                    <BackgroundColorContext.Provider value={backgroundColor}>
                        {children}
                    </BackgroundColorContext.Provider>
                </div>
            </section>
        )
    }
}

export default Chapter